import getWithToken from './base/get-with-token'

const getCustomerLinks = (id, page, limit) => getWithToken(`/customer/${id}/link?page=${page}&limit=${limit}`)()

export default getCustomerLinks